export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">编辑精选优质黑料视频内容，每日更新不容错过</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Entertainment%20news%20coverage%20scene%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20warm%20golden%20accents%2C%20professional%20studio%20setting%2C%20cinematic%20composition%2C%20mysterious%20vibe%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20luxurious%20interior&width=600&height=450&seq=card-01-2026&orientation=landscape"
                alt="娱乐圈年度最火爆黑料盘点"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">独家</span>
                <span className="text-xs text-foreground-500">2026-07-19</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">娱乐圈年度最火爆黑料大盘点，这些内幕你绝对不能错过</h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">汇集本年度娱乐圈最有看点的黑料视频，从明星恋情到综艺内幕，一一为你揭晓。</p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 892.5万</span>
                <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 3.2万</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Entertainment%20news%20coverage%20scene%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20warm%20golden%20accents%2C%20professional%20studio%20setting%2C%20cinematic%20composition%2C%20mysterious%20vibe%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20luxurious%20interior&width=600&height=450&seq=card-02-2026&orientation=landscape"
                alt="网红圈最新爆料汇总"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">热搜</span>
                <span className="text-xs text-foreground-500">2026-07-18</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">网红圈最新爆料汇总：那些你不知道的幕后故事都在这里</h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">头部网红们的黑料视频全收录，从直播翻车到私下真面目，黑料视频为你深度还原。</p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 654.8万</span>
                <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 2.7万</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Entertainment%20news%20coverage%20scene%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20warm%20golden%20accents%2C%20professional%20studio%20setting%2C%20cinematic%20composition%2C%20mysterious%20vibe%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20luxurious%20interior&width=600&height=450&seq=card-03-2026&orientation=landscape"
                alt="综艺节目幕后真相揭秘"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-900 text-xs font-medium rounded-full">深挖</span>
                <span className="text-xs text-foreground-500">2026-07-17</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">综艺节目幕后真相大揭秘，这些镜头从未在电视上出现过</h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">热门综艺背后的黑料视频曝光，剪辑师不敢放的片段，黑料视频独家呈现。</p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 437.1万</span>
                <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 1.9万</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Entertainment%20news%20coverage%20scene%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20warm%20golden%20accents%2C%20professional%20studio%20setting%2C%20cinematic%20composition%2C%20mysterious%20vibe%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20luxurious%20interior&width=600&height=450&seq=card-04-2026&orientation=landscape"
                alt="明星私下真实状态曝光"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">独家</span>
                <span className="text-xs text-foreground-500">2026-07-16</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">明星私下真实状态大曝光，镜头前后的反差你敢信？</h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">黑料视频独家获取多位明星私下影像资料，真实状态与荧幕形象差距惊人。</p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 1,203.6万</span>
                <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 5.8万</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200 group">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Entertainment%20news%20coverage%20scene%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20warm%20golden%20accents%2C%20professional%20studio%20setting%2C%20cinematic%20composition%2C%20mysterious%20vibe%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20luxurious%20interior&width=600&height=450&seq=card-05-2026&orientation=landscape"
                alt="音乐圈黑料深度追踪"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">追踪</span>
                <span className="text-xs text-foreground-500">2026-07-15</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">音乐圈黑料视频深度追踪，这些歌手的真实面目让人大跌眼镜</h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">从选秀黑幕到抄袭争议，黑料视频为你梳理音乐圈最全黑料事件时间线。</p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 329.4万</span>
                <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 1.5万</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}